// extracted by mini-css-extract-plugin
export default {"container":"TagPage_container__x36Td","textContainer":"TagPage_textContainer__ULLzC","productCard":"TagPage_productCard__h+glN"};